export const GridTitleFile = "File"
export const GridTitleStatement = "Statement"
export const GridTitleTradeConfirm = "TradeConfirm"